import React from 'react'
import { Button } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { MovementVariant } from '../utils/types'

interface Props {
  variant: MovementVariant
  onClick: (variant: MovementVariant) => void
}

export const RecordMovementButton: React.FC<Props> = ({ variant, onClick }) => {
  const t = useT()

  return (
    <>
      <Button
        variant={variant === MovementVariant.Remove ? 'no' : 'go'}
        onClick={() => onClick(variant)}
      >
        {variant === MovementVariant.Remove
          ? t('Remove cash', { _context: 'Button' })
          : t('Add cash', { _context: 'Button' })}
      </Button>
    </>
  )
}
